/**
 * Fecha local de hoy en formato YYYY-MM-DD, sin desfase UTC.
 * Usar en lugar de new Date().toISOString().slice(0,10)
 */
export function localDate() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Formatea una fecha de MySQL (Date | string) como DD/MM/YYYY.
 * Retorna '—' si el valor es nulo/vacío.
 *
 * Reglas anti-desfase de zona horaria:
 *  - Date object → extrae partes UTC (MySQL2 serializa la fecha local como UTC+offset)
 *  - string      → toma los primeros 10 chars "YYYY-MM-DD" sin parsear a Date
 */
export function fmtFecha(d) {
  if (!d) return '—';
  let y, m, dia;
  if (d instanceof Date) {
    y   = d.getUTCFullYear();
    m   = String(d.getUTCMonth() + 1).padStart(2, '0');
    dia = String(d.getUTCDate()).padStart(2, '0');
  } else {
    const s = String(d).slice(0, 10); // toma "YYYY-MM-DD" de cualquier ISO-8601
    [y, m, dia] = s.split('-');
  }
  if (!y || !m || !dia) return '—';
  return `${dia}/${m}/${y}`;
}

/**
 * Formatea una fecha+hora (Date | string) como HH:MM.
 */
export function fmtHora(d) {
  if (!d) return '';
  const dt = typeof d === 'string' ? new Date(d) : d;
  const h  = String(dt.getHours()).padStart(2, '0');
  const mi = String(dt.getMinutes()).padStart(2, '0');
  return `${h}:${mi}`;
}

/**
 * Formatea una cantidad: entero si no tiene decimales, .2f si los tiene.
 * Ej: 5 → "5", 5.5 → "5.50"
 */
export function fmtCant(n) {
  const v = parseFloat(n);
  if (isNaN(v)) return '—';
  return v % 1 === 0 ? String(parseInt(v, 10)) : v.toFixed(2);
}

/**
 * Formatea dinero en locale es-PE con dos decimales.
 * Ej: 1234.5 → "1,234.50"
 */
export function fmtMoney(n) {
  return Number(n || 0).toLocaleString('es-PE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
